export default "/assets/dc9fc18fe8739f9e.svg"